<template>
  <div class="w-full bg-white border rounded border-gray-200 shadow-sm px-5 py-7 leading-5">
    <span class="text-lg font-medium">Olá, {{ client.name }}</span>
    <p class="py-1">
        Nesta página você consegue acompanhar o histórico de seus atendimentos :)
      </p>
      <p class="py-1">
        Caso existam notificações com o símbolo <span class="inline-flex w-4 h-4 text-xs justify-center bg-orange-organization text-white rounded-full">1</span>
        significa que você precisa preencher algumas informações para
        prosseguirmos com o seu atendimento, combinado?
      </p>
      <p class="py-1" v-if="organization === 'MOBLY' && type !== 'lead'">
        Mas, caso você precise abrir um novo atendimento, acesse o painel de
        <a class="text-blue-400 hover:underline" :href="`${customerPanelBaseUrl}/meus-pedidos`">Meus Pedidos</a>,
        selecione o produto sobre o qual deseja falar, e clique em “abrir
        um atendimento para este item”.
      </p>
  </div>
</template>

<script>
import { findOne as findOneCustomer } from '@/repositories/integrations/mobly/services/csExternal/customer'
import { findOne as findOneLead } from '@/repositories/integrations/mobly/services/csExternal/lead'

export default {
  name: 'ExternalClientInfo',

  props: {
    clientDocument: String,
    organization: String,
    hash: String,
    type: String
  },

  data () {
    return {
      loading: true,
      client: {},
      loadingError: false,
      customerPanelBaseUrl: process.env.VUE_APP_CUSTOMER_PANEL_BASE_URL
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    async init () {
      this.loading = true

      try {
        // Get Customer
        const clientParams = `fields=name&hash=${this.hash}`
        if (this.type === 'lead') {
          const clientResponse = await findOneLead(
            this.clientDocument, clientParams, this.organization
          )
          this.client = clientResponse.data
        } else {
          const clientResponse = await findOneCustomer(
            this.clientDocument, clientParams, this.organization
          )
          this.client = clientResponse.data
        }
      } catch (err) {
        if (err.response.status === 401) {
          window.location.href = '/unauthorized'
        }
      }

      this.loading = false
    }
  }
}
</script>
